import { DatePicker } from '@mui/lab';
import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import {
  LotsManagementVM,
  FiltertLotsManagemenVM,
} from 'front-office/view-models/lots-management/list';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import OperatorList from 'front-office/components/shared/operator-list';
import Services from './service-list';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<LotsManagementVM>();

  const { userProfile } = useUserProfile();

  const onChange = useEventCallback(
    (
      key: keyof FiltertLotsManagemenVM,
      value: FiltertLotsManagemenVM[keyof FiltertLotsManagemenVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <Services
          value={formContext.values?.filter?.service || ''}
          onChange={(event) => onChange('service', event.target.value)}
          label="Servizio"
          disabled={formContext.values?.filter?.isDisabledService || false}
          fgCashManagement="S"
        />
      </Grid>
      <Grid item xs={12} md={5}>
        {formContext.values?.filter?.isDisabledOperator ? (
          <PmiTextField
            label="Operatore"
            aria-label="Operatore"
            fullWidth
            id="operator"
            value={formContext.values?.filter?.operator || ''}
            disabled={formContext.values?.filter?.isDisabledOperator || false}
            onChange={(event) => onChange('operator', event.target.value)}
          />
        ) : (
          <OperatorList
            fgCashManagement={formContext.values?.filter?.service === 'ALL'}
            idService={formContext.values?.filter?.service || ''}
            auth={userProfile?.datiLogin?.profile?.feature?.controlloDiCassa}
            value={formContext.values?.filter?.operator || ''}
            onChange={(value) => onChange('operator', value)}
            disabled={!Boolean(formContext.values?.filter?.service)}
          />
        )}
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data assegnazione da *"
          aria-label="Data assegnazione da"
          value={formContext.values?.filter?.dateFrom || null}
          onChange={(date) => {
            onChange('dateFrom', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateFrom"
              fullWidth
              error={
                (formContext.errors.filter as FormikTouched<FiltertLotsManagemenVM>)?.dateFrom &&
                Boolean(
                  (formContext.errors.filter as FormikErrors<FiltertLotsManagemenVM>)?.dateFrom
                )
              }
              helperText={
                (formContext.errors.filter as FormikErrors<FiltertLotsManagemenVM>)?.dateFrom
              }
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data assegnazione a *"
          aria-label="Data assegnazione aa"
          value={formContext.values?.filter?.dateTo || null}
          onChange={(date) => {
            onChange('dateTo', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateTo"
              fullWidth
              error={
                (formContext.errors.filter as FormikTouched<FiltertLotsManagemenVM>)?.dateTo &&
                Boolean((formContext.errors.filter as FormikErrors<FiltertLotsManagemenVM>)?.dateTo)
              }
              helperText={
                (formContext.errors.filter as FormikErrors<FiltertLotsManagemenVM>)?.dateTo
              }
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Lots Management List - Filter - Form';

export default FormFilter;
